module.exports = __webpack_public_path__ + "static/img/icon-connect.24c797fc.png";